import { combineReducers } from 'redux-immutable'
import {AUDIO_REDUCER, GENERAL_REDUCER, VIDEO_REDUCER} from './consts'
import generalReducer from './general/reducer'
import audioReducer from './audio/reducer'
import videoReducer from './video/reducer'

// eslint-disable-next-line import/no-anonymous-default-export
export default combineReducers({
  [GENERAL_REDUCER]: generalReducer,
  [AUDIO_REDUCER]: audioReducer,
  [VIDEO_REDUCER]: videoReducer,
})
